import ProofPaymentScreen from './ProofPayment';

export {ProofPaymentScreen};
